/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';

import Vue from 'vue';

// Addmonte captcha
import Captcha from "../../vendor/addmonte/captcha/resources/js/install";

Vue.use(Captcha, {siteKey: process.env.MIX_CAPTCHA_SITEKEY});


import i18n, {addTranslation} from 'vue-language';

import Noty from './plugins/Noty';
// import VueI18n from 'vue-i18n'
import VueCardFormat from 'vue-credit-card-validation';
import AjaxErrorParser from './plugins/AjaxErrorParser';
import VueCarousel from 'vue-carousel';

Vue.use(Noty);
Vue.use(VueCardFormat);
Vue.use(AjaxErrorParser);
Vue.use(VueCarousel);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Package components
Vue.component('vue-cookie-law', require('vue-cookie-law').default);

Vue.component('vue-checkout-fill-shipping-data-button', require('./components/CheckoutFillShippingDataButton.vue').default);
Vue.component('vue-newsletter-sign-up-modal', require('./components/MailchimpSignUpComponent.vue').default);
Vue.component('vue-gastrotour-booking', require('./components/bookingAndEnquiry/GastrotourBookingComponent.vue').default);
Vue.component('vue-gastrotour-enuiry', require('./components/bookingAndEnquiry/GastrotourEnquiryComponent.vue').default);
Vue.component('vue-event-booking', require('./components/bookingAndEnquiry/EventBookingComponent.vue').default);
Vue.component('vue-testimonial-create', require('./components/testimonialCreate/Create.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

addTranslation({
    hu: require('./lang/hu').default,
});

const app = new Vue({
    el: '#app',
    i18n,
    data: {
        showNewsletterSignUpModal: false,
    },
    mounted() {

        this.$el.querySelectorAll('[data-bs-toggle="newsletter-modal"]')
            .forEach(element => {
                element.addEventListener('click', event => {
                    this.showNewsletterSignUpModal = true;
                });
            });

    },
});
